export default __webpack_public_path__ + "5b46b828066c65adebe86f148739b710.png";